/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';

/**
 * 
 * @export
 * @interface PickupPoint
 */
export interface PickupPoint {
    /**
     * 
     * @type {string}
     * @memberof PickupPoint
     */
    id?: string;
    /**
     * 
     * @type {Address}
     * @memberof PickupPoint
     */
    address?: Address;
    /**
     * 
     * @type {number}
     * @memberof PickupPoint
     */
    straightLineDistance?: number;
    /**
     * 
     * @type {number}
     * @memberof PickupPoint
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof PickupPoint
     */
    longitude?: number;
}

/**
 * Check if a given object implements the PickupPoint interface.
 */
export function instanceOfPickupPoint(value: object): boolean {
    return true;
}

export function PickupPointFromJSON(json: any): PickupPoint {
    return PickupPointFromJSONTyped(json, false);
}

export function PickupPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): PickupPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
        'straightLineDistance': json['straightLineDistance'] == null ? undefined : json['straightLineDistance'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
    };
}

export function PickupPointToJSON(value?: PickupPoint | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'address': AddressToJSON(value['address']),
        'straightLineDistance': value['straightLineDistance'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

